import { useNavigate } from "react-router-dom";
import styled from "styled-components";

export default function Sidebar({ menuAtivo }) {
  const navigate = useNavigate();

  if (!menuAtivo) {
    return null;
  }

  return (
    <SidebarContainer>

      <Title>
        {menuAtivo.nome}
      </Title>

      <MenuList>

        {menuAtivo.itens?.map((item) => (

          <SidebarButton
            key={item.id}
            onClick={() => navigate(item.rota)}
            type="button"
          >
            {item.nome}
          </SidebarButton>

        ))}

      </MenuList>

    </SidebarContainer>
  );
}

const SidebarContainer = styled.aside`
  width: 240px;

  background: #ffffff;

  border-right: 1px solid #e6e9ef;

  padding: 22px 14px;

  animation: abrirSidebar 0.2s ease;

  @keyframes abrirSidebar {
    from {
      opacity: 0;
      transform: translateX(-10px);
    }

    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
`;

const Title = styled.h3`
  padding: 0 12px 14px;

  color: #2e7d6e;

  font-size: 14px;

  text-transform: uppercase;

  letter-spacing: 0.7px;
`;

const MenuList = styled.div`
  display: flex;
  flex-direction: column;

  gap: 5px;
`;

const SidebarButton = styled.button`
  width: 100%;

  border: none;

  border-radius: 8px;

  padding: 11px 14px;

  background: transparent;

  text-align: left;

  font-size: 14px;

  color: #58636e;

  cursor: pointer;

  transition:
    background 0.2s ease,
    color 0.2s ease,
    transform 0.15s ease;

  &:hover {
    background: #edf7f4;

    color: #2e7d6e;

    transform: translateX(3px);
  }

  &:active {
    transform: translateX(3px) scale(0.98);
  }
`;